import { render, staticRenderFns } from "./ClientName.vue?vue&type=template&id=021189f0"
import script from "./ClientName.vue?vue&type=script&lang=js"
export * from "./ClientName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports